var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SelectWithInfinite',{attrs:{"textFloat":_vm.textFloat,"options":_vm.branchList,"textField":_vm.textField,"valueField":_vm.valueField,"multiple":false,"clearable":false,"placeholder":"Select Branch","value":_vm.value,"isRequired":_vm.isRequired,"isValidate":_vm.isValidate,"v":_vm.v,"rawValue":""},on:{"input":_vm.valueInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }